import { FeatureType } from "interfaces/feature-tracker";
import { baseApi } from "../api";

export const poisBountyApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		selectPoisEvent: builder.mutation({
			query: (body: { eventId: string; otherEventId: string }) => {
				return {
					url: `/rest/poisBounty/v3/select-event?eventId=${body.eventId}&otherEventId=${body.otherEventId}`,
					method: "POST"
				};
			} /* ,
			invalidatesTags: [
				{ type: "featureTrackerTag", id: FeatureType.POIS_BOUNTY_V3 }
			] */
		}),
		setInitialDisplay: builder.mutation({
			query: (body: { eventId: string }) => {
				return {
					url: `/rest/poisBounty/v3/set-initial-display?eventId=${body.eventId}`,
					method: "POST"
				};
			}
			//invalidatesTags: [{ type: "featureTrackerTag", id: FeatureType.POIS_BOUNTY_V3 }]
		}),
		createCycleTracker: builder.mutation({
			query: (body: { eventId: string }) => {
				const queryParams = new URLSearchParams();
				for (const [key, value] of Object.entries(body)) {
					queryParams.append(key, value.toString());
				}
				return {
					url: `/rest/poisBounty/createCycleTracker?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: [
				{ type: "featureTrackerTag", id: FeatureType.POIS_BOUNTY_V3 }
			]
		}),
		postPbMetadata: builder.mutation({
			query: (body: { [key: string]: string | number | boolean }) => {
				const queryParams = new URLSearchParams();
				for (const [key, value] of Object.entries(body)) {
					queryParams.append(key, value.toString());
				}
				return {
					url: `/rest/poisBounty/v3/metadata/value?${queryParams.toString()}`,
					method: "POST"
					//body
				};
			},
			invalidatesTags: [
				{ type: "featureTrackerTag", id: FeatureType.POIS_BOUNTY_V3 }
			]
		}),
		pbDisplayed: builder.mutation({
			query: (body: { eventId: string }) => {
				const queryParams = new URLSearchParams();
				for (const [key, value] of Object.entries(body)) {
					queryParams.append(key, value.toString());
				}
				return {
					url: `/rest/poisBounty/v3/displayed?${queryParams.toString()}`,
					method: "POST"
					//body
				};
			} /* ,
			invalidatesTags: [
				{ type: "featureTrackerTag", id: FeatureType.POIS_BOUNTY_V3 }
			] */
		}),
		pbGetInactiveTracker: builder.mutation({
			query: (body: { activeOnly: boolean }) => {
				const queryParams = new URLSearchParams();
				for (const [key, value] of Object.entries(body)) {
					queryParams.append(key, String(value));
				}
				return {
					url: `/rest/poisBounty/v3/trackers?${queryParams.toString()}`
				};
			} /* ,
			invalidatesTags: [
				{ type: "featureTrackerTag", id: FeatureType.POIS_BOUNTY_V3 }
			] */
		}),
		// Debug endpoints not used in production
		contributeLP: builder.mutation({
			query: (body: { userId: string; loyaltyPoints: number }) => {
				const queryParams = new URLSearchParams();
				for (const [key, value] of Object.entries(body)) {
					queryParams.append(key, value.toString());
				}
				return {
					url: `/rest/debug/poisBounty/v3/contribute-loyalty-points?${queryParams.toString()}`,
					method: "POST"
				};
			},
			invalidatesTags: [
				{ type: "featureTrackerTag", id: FeatureType.POIS_BOUNTY_V3 }
			]
		})
	})
});

export const {
	useContributeLPMutation,
	useCreateCycleTrackerMutation,
	usePbDisplayedMutation,
	usePostPbMetadataMutation,
	useSelectPoisEventMutation,
	useSetInitialDisplayMutation,
	usePbGetInactiveTrackerMutation
} = poisBountyApi;
